// src/components/SchoolStats.js
import React, { useMemo, useState } from 'react';
import { 
  hasSchoolProblems,
  countSchoolProblems,
  getSchoolProblemsList,
  getSchoolCompliance,
  getSchoolTimeliness,
  hasTimelinessProblems
} from '../utils/calculations';

const SchoolStats = ({ school, schoolData, filters }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const statistics = useMemo(() => {
    const allData = {
      dates: schoolData.dates,
      errors: schoolData.errors,
      publication: schoolData.publication,
      compliance: schoolData.compliance,
      timeliness: schoolData.timeliness
    };
    
    const hasProblems = hasSchoolProblems(school, allData, filters);
    const problemsCount = countSchoolProblems(school, allData, filters);
    const problemsList = getSchoolProblemsList(school, allData, filters);
    const complianceAvg = getSchoolCompliance(school, schoolData.compliance);
    const federalMonitoringUrl = `https://monitoring.cemon.ru/#/profile?id=${school.Код}`;

    return {
      hasProblems,
      problemsCount,
      problemsList,
      complianceAvg,
      federalMonitoringUrl
    };
  }, [school, schoolData, filters]);

  const { hasProblems, problemsCount, problemsList, complianceAvg, federalMonitoringUrl } = statistics;

  return (
    <div className="stats-grid" id="school-stats">
      <div className="stat-card">
        <div className="stat-label">Статус</div>
        <div className={`stat-value ${hasProblems ? 'error' : 'success'}`}>
          {hasProblems ? 'Есть проблемы' : 'Нет проблем'}
        </div>
      </div>
      
      <div className="stat-card problem-stat-card">
        <div className="stat-label">Количество проблем</div>
        <div 
          className={`stat-value problems-count-value ${problemsCount > 0 ? 'warning' : 'success'}`}
          onMouseEnter={() => problemsCount > 0 && setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          style={{ position: 'relative', cursor: problemsCount > 0 ? 'help' : 'default' }}
        >
          {problemsCount}
          {showTooltip && problemsCount > 0 && (
            <div className="problems-tooltip">
              <div className="tooltip-title">Список проблем:</div>
              <ul className="tooltip-list">
                {problemsList.map((problem, index) => (
                  <li key={index}>{problem}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      
      <div className="stat-card">
        <div className="stat-label">Среднее соответствие</div>
        <div className={`stat-value ${
          complianceAvg > 90 ? 'success' : 
          complianceAvg > 70 ? 'warning' : 'error'
        }`}>
          {complianceAvg.toFixed(1)}%
        </div>
      </div>
      
      <div className="stat-card">
        <div className="stat-label">Федеральный мониторинг</div>
        <div className="stat-value">
          <a 
            href={federalMonitoringUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="federal-link"
          >
            Открыть профиль
          </a>
        </div>
      </div>
    </div>
  );
};

export default SchoolStats;